/**
 * Created by tomers on 2/23/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/data-sources/integrations/integrationsCategoriesItemView.tmpl");
    var IntegrationsRowItemView = require("manager-views/data-sources/integrations/IntegrationsRowItemView");

    var IntegrationsCategoriesItemView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        IntegrationsCategoriesItemView = Marionette.CompositeView.extend({
            className: "integration-category-container",
            itemView: IntegrationsRowItemView,
            itemViewContainer : "tbody",
            template: template,
            ui: {
                firstColumn: ".first",
                secondColumn: ".second",
                thirdColumn: ".third"
            },

            initialize: function (options) {
                this._initialize(options);
            },
            onRender: function () {
                this._onRender();
            },

            customTemplateHelpers: function() {
                var title = this.model.getName();
                var firstColumnTitle = this.firstColumnData.name;
                var secondColumnTitle = this.secondColumnData.name;
                var thirdColumnTitle = this.thirdColumnData.name;

                return {
                    title: title,
                    firstColumnTitle: firstColumnTitle,
                    secondColumnTitle: secondColumnTitle,
                    thirdColumnTitle: thirdColumnTitle
                };
            },

            _initialize: function (options) {
                this.model = options.model;
                this.collection = this._getCollection();

                this.firstColumnData = this.model.getFirstColumnData();
                this.secondColumnData = this.model.getSecondColumnData();
                this.thirdColumnData = this.model.getThirdColumnData();
            },

            _onRender: function () {
                if (!this.firstColumnData.show) {
                    this.ui.firstColumn.hide();
                }
                if (!this.secondColumnData.show) {
                    this.ui.secondColumn.hide();
                }
                if (!this.thirdColumnData.show) {
                    this.ui.thirdColumn.hide();
                }
                if (!_.isUndefined(this.firstColumnData.width)) {
                    this.ui.firstColumn.css("width", this.firstColumnData.width);
                }
                if (!_.isUndefined(this.secondColumnData.width)) {
                    this.ui.secondColumn.css("width", this.secondColumnData.width);
                }
                if (!_.isUndefined(this.thirdColumnData.width)) {
                    this.ui.thirdColumn.css("width", this.thirdColumnData.width);
                }
            },

            _getCollection: function() {
                var collection = this.model.getRowsCollection();
                var modelsToRemove = collection.filter(function(model){
                    return !model.getShow();
                });

                _.each(modelsToRemove, function(model){
                    collection.remove(model);
                });

                return collection;
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return IntegrationsCategoriesItemView;
});
